import { render, staticRenderFns } from "./ADpageWithWxForm1.vue?vue&type=template&id=71770490&scoped=true&"
import script from "./ADpageWithWxForm1.vue?vue&type=script&lang=tsx&"
export * from "./ADpageWithWxForm1.vue?vue&type=script&lang=tsx&"
import style0 from "./ADpageWithWxForm1.vue?vue&type=style&index=0&id=71770490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71770490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71770490')) {
      api.createRecord('71770490', component.options)
    } else {
      api.reload('71770490', component.options)
    }
    module.hot.accept("./ADpageWithWxForm1.vue?vue&type=template&id=71770490&scoped=true&", function () {
      api.rerender('71770490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/willingADpages/ADpageWithWxForm1.vue"
export default component.exports